import { data } from '../../svg/OpenInNew/data';
import { makeIcon } from '../makeIcon';

export const OpenInNew = makeIcon(data, 'open_in_new', 'OpenInNew');

export default OpenInNew;
